(function () {
  function equalize(root) {
    if (!root) return;
    var cols = root.querySelectorAll('.et-size-compare__col');
    if (!cols.length) return;

    var rowsByCol = [];
    for (var i = 0; i < cols.length; i++) {
      rowsByCol.push(cols[i].querySelectorAll('.et-size-compare__row'));
    }

    var maxRowCount = 0;
    rowsByCol.forEach(function (rows) {
      if (rows.length > maxRowCount) maxRowCount = rows.length;
    });

    /* 1) Reset existing min-heights so we measure natural sizes */
    rowsByCol.forEach(function (rows) {
      for (var j = 0; j < rows.length; j++) {
        rows[j].style.minHeight = '';
      }
    });

    /* 2) For each row index — find max natural height across all columns */
    for (var idx = 0; idx < maxRowCount; idx++) {
      var maxH = 0;
      rowsByCol.forEach(function (rows) {
        var r = rows[idx];
        if (r) {
          var h = r.getBoundingClientRect().height;
          if (h > maxH) maxH = h;
        }
      });
      /* 3) Apply max as min-height to all rows at this index */
      rowsByCol.forEach(function (rows) {
        var r = rows[idx];
        if (r) r.style.minHeight = maxH + 'px';
      });
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="et-size-compare"]').forEach(equalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Fonts load can change row heights — re-equalize once ready */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }

  /* Re-run on viewport changes (debounced) */
  window.addEventListener('resize', debounce(initAll, 150));

  /* Theme editor: re-run when section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="et-size-compare"]');
    if (root) equalize(root);
  });
})();
